'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byNumeric = exports.byAlpha3 = exports.byAlpha2 = exports.codes = undefined;

var _data = require('./data');

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byAlpha2 = Object.create(null); // https://www.iso.org/obp/ui/#search/code/
// http://www.nationsonline.org/oneworld/country_code_list.htm

var byAlpha3 = Object.create(null);
var byNumeric = Object.create(null);

for (var i = 0, il = _data2.default.length; i < il; i++) {
  var code = _data2.default[i];
  var alpha2 = code.alpha2,
      alpha3 = code.alpha3,
      numeric = code.numeric;

  byAlpha2[alpha2] = code;
  byAlpha3[alpha3] = code;
  byNumeric[numeric] = code;
}

exports.codes = _data2.default;
exports.byAlpha2 = byAlpha2;
exports.byAlpha3 = byAlpha3;
exports.byNumeric = byNumeric;
exports.default = {
  codes: _data2.default,
  byAlpha2: byAlpha2,
  byAlpha3: byAlpha3,
  byNumeric: byNumeric
};